import {Component, Input} from '@angular/core';
import {WarningArrayItemDeletionComponent,} from '../../../../warning-array-item-deletion/warning-array-item-deletion.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {AdvancedFormArray} from "@magieno/angular-advanced-forms";
import { AdvancedForm } from "@magieno/angular-advanced-forms";
import {AdvancedFormGroup} from "@magieno/angular-advanced-forms";
import {IncomeTaxPersonalChildInRrspOptions} from "../../../../../../../../../../../common/src/options/calculations/rrsp/income-tax/personal/income-tax-personal-child-in-rrsp.options";
import {IncomeTaxPersonalInRrspOptions} from "../../../../../../../../../../../common/src/options/calculations/rrsp/income-tax/personal/income-tax-personal-in-rrsp.options";
import {RrspOptions} from "../../../../../../../../../../../common/src/options/calculations/rrsp/rrsp.options";


@Component({
  selector: 'app-rrsp-personal-tax-children-form',
  templateUrl: './rrsp-personal-tax-children-form.component.html',
  styleUrls: ['./rrsp-personal-tax-children-form.component.scss'],
  standalone: false,
})
export class RrspPersonalTaxChildrenFormComponent {

  @Input()
  children: AdvancedFormArray<IncomeTaxPersonalChildInRrspOptions>;
  @Input()
  form: AdvancedForm<RrspOptions>;

  constructor(public modalService: NgbModal) {

  }

  get incomeTaxPersonalForm(): AdvancedFormGroup<IncomeTaxPersonalInRrspOptions> {
    return this.form.formElements.personalIncomeTaxOptions as AdvancedFormGroup<IncomeTaxPersonalInRrspOptions>;
  }

  async removeChild(childIndexToRemove: number) {
    const modal = this.modalService.open(WarningArrayItemDeletionComponent, {});
    (modal.componentInstance as WarningArrayItemDeletionComponent).objectDefinition = 'cet enfant';
    modal.closed.subscribe(async result => {
      if (result === true) {
        // Here we delete only in the form, not syncing the change to the server or else deleting could cause bad data to be sync.
        this.children.delete(childIndexToRemove);

        return;
      }
    });

    return;
  }

  addChild() {
    this.children.appendNew();
  }

}
